/**
 * Ce qui se porte sur <body> (la liste du Select, l'Infobulle, le Menu, la Modale) : deux outils.
 *
 * `cadreDuTheme` : le thème de l'ENDROIT, recopié sur l'enveloppe du portail — `.dark` et
 * `data-theme` sont lus sur l'ancêtre le plus proche de l'ancre, parce que le catalogue aligne
 * les trois thèmes côte à côte dans une même page (au cockpit et sur Helios ils sont sur <html>,
 * et l'enveloppe les redit sans mal).
 *
 * `vueDuCorps` / `rectVue` : le facteur `zoom` posé sur <body> (le cockpit : la taille
 * d'affichage, `--zoom-affichage`). 🩸 Un `position: fixed` rendu sous un body zoomé compte en
 * pixels de MISE EN PAGE, alors que `getBoundingClientRect` et `clientX` parlent en pixels
 * d'ÉCRAN : sans la division, un menu ouvert à 1 200 px atterrit à 960 quand l'affichage est à
 * 80 % (mesuré dans Chrome 148 au cockpit, `core/theme/tailleAffichage.ts`). Tout ce qui se pose
 * en `fixed` sur <body> mesure donc par ici.
 */
export interface CadreTheme {
  sombre: boolean;
  theme?: string;
}

export function cadreDuTheme(el: Element | null | undefined): CadreTheme {
  return {
    sombre: !!el?.closest(".dark"),
    theme: el?.closest<HTMLElement>("[data-theme]")?.dataset.theme,
  };
}

/** La fenêtre, en pixels de mise en page. */
export interface Vue {
  zoom: number;
  largeur: number;
  hauteur: number;
}

export function vueDuCorps(): Vue {
  const brut = Number(window.getComputedStyle(document.body).zoom);
  const zoom = Number.isFinite(brut) && brut > 0 ? brut : 1;
  return { zoom, largeur: window.innerWidth / zoom, hauteur: window.innerHeight / zoom };
}

export interface RectVue {
  left: number;
  top: number;
  right: number;
  bottom: number;
  width: number;
  height: number;
}

/** Le rectangle d'un élément, en pixels de mise en page (divisé par le zoom du body). */
export function rectVue(el: Element | null | undefined, zoom: number): RectVue | undefined {
  const r = el?.getBoundingClientRect();
  if (!r) return undefined;
  return {
    left: r.left / zoom,
    top: r.top / zoom,
    right: r.right / zoom,
    bottom: r.bottom / zoom,
    width: r.width / zoom,
    height: r.height / zoom,
  };
}
